import { Model } from "@vuex-orm/core";
import config from "../configs/BuildingMajorities";
import Building from "./Building";
import Majority from "./Majority";

export default class BuildingMajorities extends Model {
  static get entity() {
    return "building_majorities";
  }

  static fields() {
    return {
      id: this.attr(null),
      building_id: this.attr(null),
      majority_id: this.attr(null),
      created: this.attr(null),
      updated: this.attr(null),
      deleted: this.attr(null), // ???: ..

      building: this.belongsTo(Building, "building_id"),
      majority: this.belongsTo(Majority, "majority_id"),
      agency_id: this.attr(null),
    };
  }
  static get apiConfig() {
    return config;
  }
}
